angular.module('jv.Dashboard.MyOpenJobs.Controller', ['jv.choose.add.reqs.form.directive'])
.controller('jv.Dashboard.MyOpenJobs.Controller', ['$scope', 'jvDashboardAjaxService','$timeout', 'jvContextualLoadingService', '$rootScope','jvDashboardFactory', 'jvSearchUrlRedirectService',
    function($scope, jvDashboardAjaxService, $timeout, jvContextualLoadingService, $rootScope,jvDashboardFactory, jvSearchUrlRedirectService) {
        $scope.userWorkflows = [];
        $scope.userReqInfo = {};
        $scope.userReqInfo.reqList = [];
        var userWorkflowValues = [];

        $scope.totalCount = 0;
        $scope.pageSize = 10;
        $scope.currentPage = 0;
        var initialPageNumber = 0, sortBy, sortOrder, postingTypes, subsidiaries, regions, locations, departments, categories, reqTypes, sourceIds, hiringManagerIds;

        // all flags here
        $scope.flags = {
            'showNoReqsError': false // will be used to show the error message.
        };

        //config to keep track of user permissions
        $scope.userPermissions = {
            canAddRequisition: _permissions.canAddRequisition
        };
        // Get workflows associated with the user.
        function getUserWorkflows() {
            var settingsInfo = $scope.widgetObject.userWidgetSettings.widgetSetting;

            angular.forEach(settingsInfo, function(settingInfo, index){
                var values;
                if (settingInfo.userValues) {
                    values = settingInfo.userValues;
                } else if(settingInfo.settings.defaultValues){
                    values = settingInfo.settings.defaultValues;
                }

                if(values){
                    if(values[0] && angular.isObject(values[0].label) && values[0].EId){
                        values[0].value = angular.copy(values[0].EId);
                        if(values[0].label.name) {
                            values[0].label = angular.copy(values[0].label.name);
                        }
                        /*
                         *  The API for fetching the list of hiring managers has the name returned as fullName.
                         *  We need this for the hiring manager filter in settings
                         */
                        else if(values[0].label.fullName) {
                            values[0].label = angular.copy(values[0].label.fullName);
                        }
                        delete values[0].EId;
                    } else if(values[0].label && values[0].label.name){
                        //filters with label and no EId property Eg: SourceType
                        //posting type has index attribute. Check for undefined as 0 can be a value
                        if( (values[0].label.index != undefined) && (values[0].label.index !== null) ){
                            values[0].index = angular.copy(values[0].label.index);
                        }
                        values[0].value = angular.copy(values[0].label.name);
                        values[0].label = angular.copy(values[0].label.name);
                    }
                    //Making sure UI doesnt make a call with all filter
                    if($.isEmptyObject(values[0].label)){
                        values[0].label = '';
                        values[0].value = null;
                    }
                    switch(settingInfo.settings.name) {
                        case "WorkflowSteps":
                            $scope.userWorkflows = values;
                            break;
                        case "SortBy":
                            sortBy = values[0].value;
                            break;
                        case "SortOrder":
                            sortOrder = values[0].value;
                            break;
                        case "PostingType":
                            if(values[0]){
                                //check for undefined as 0 can be a value
                                if( (values[0].index != undefined)  && (values[0].index !== null) ){
                                    values[0].value = angular.copy(values[0].index);
                                    delete values[0].index;
                                }
                            }
                            postingTypes = values[0].value;
                            break;
                        case "Company":
                            subsidiaries = values[0].value;
                            break;
                        case "Region":
                            regions = values[0].value;
                            break;
                        case "Location":
                            locations = values[0].value;
                            break;
                        case "Department":
                            departments = values[0].value;
                            break;
                        case "Category":
                            categories = values[0].value;
                            break;
                        case "RequisitionType":
                            reqTypes = values[0].value;
                            break;
                        case "SourceType":
                            sourceIds = values[0].value;
                            $scope.sourceNameFilter = sourceIds;
                            break;
                        case "HiringManager":
                            hiringManagerIds = values[0].value;
                            break;
                        default:
                            break;
                    }
                }

            });

            angular.forEach($scope.userWorkflows, function(userWorkflow, index) {
                /**
                    We are checking for userWorkflow.title here because when user configures the workflow we make a call to an endpoint which sends
                    back each workflow object with properties EId: "zpV9Vfw8 name: "Screened" title: "Screened". Here title is the label and value is the name .
                    value is sent back to the backend and label is used to render on the UI.
                **/
                if(userWorkflow.title){
                    userWorkflow.value = angular.copy(userWorkflow.name);
                    userWorkflow.label = angular.copy(userWorkflow.title);
                    delete userWorkflow.EId;
                    delete userWorkflow.name;
                    delete userWorkflow.title;
                }
                userWorkflowValues.push(userWorkflow.value);

            });

            $scope.getUserRequisitions(initialPageNumber);
        }

        $scope.goToNewCandidateSearch = function(workflowId, job, sourceId) {
            jvSearchUrlRedirectService.setWorkflow(workflowId);
            if (job) {
                jvSearchUrlRedirectService.setRequisition(job.EId, job.title);
            }
            else {
                jvSearchUrlRedirectService.setRequisitionType(1); // My Active Reqs
            }
            if (sourceId) {
                jvSearchUrlRedirectService.setSource(sourceId);
            }
            jvSearchUrlRedirectService.redirect();
        };

        $scope.getWorkflowStateId = function(workflowId) {
            if (workflowId === 'Active') {
                return -1;
            }
            return workflowId;
        };

        //Get requisition information to show in the widget.
        $scope.getUserRequisitions = function(page) {
            $scope.currentPage = page;

            // prepares the data for rendering in the grid.
            var massageData = function(reqList) {
                var jobHashWithWorkflowName;
                if(angular.isUndefined($scope.jobHashWithWorkflowName)){
                    jobHashWithWorkflowName = {};
                }else{
                    jobHashWithWorkflowName = $scope.jobHashWithWorkflowName;
                }

                for (var i = 0,j = reqList.length; i < j; i++) {
                    var reqObj = reqList[i];
                    jobHashWithWorkflowName[reqObj.job.EId] = {};
                    for (var ii = 0, jj = reqObj.workflowGroup.length; ii < jj; ii++) {
                        var workflow = reqObj.workflowGroup[ii];
                        //Fix for HIRE-8396 : NV
                        var title = workflow.candidateState.title.trim();
                        jobHashWithWorkflowName[reqObj.job.EId][title] = workflow.count;
                    }
                }
                $scope.jobHashWithWorkflowName = jobHashWithWorkflowName;
            };

            // callback that gets called after the user info is returned.
            var _callback = function(results) {
                 $scope.lastUpdated = results.lastUpdated;
                if (results && results.reqList) {
                    massageData(results.reqList);
                    jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                    $scope.userReqInfo.reqList = angular.copy(results.reqList);
                    $scope.totalCount = results.total;
                }
                if (results.reqList.length === 0) {
                    $scope.flags.showNoReqsError = true;
                }else{
                    $scope.flags.showNoReqsError = false;
                }
            };

            jvContextualLoadingService.show($scope.widgetObject.widgetId);

            var args = {
                page: $scope.currentPage,
                maxResults: $scope.pageSize,
                sortBy: sortBy,
                order: sortOrder,
                subsidiaryId: subsidiaries,
                regionIds: regions,
                locationIds : locations,
                departmentIds : departments,
                categoryIds : categories,
                typeIds : reqTypes,
                postingType:postingTypes,
                workflowStateNames: userWorkflowValues,
                sourceIds : sourceIds,
                hiringManagerIds :hiringManagerIds
            };
            /*
            Making sure we send refresh true for new widget creating flow
            Cannot set refresh true in the REFRESH_WIDGET emit callback since the controller gets re-initialized for a newly added widget.
            Hence storing this in the factory
            */
            if($scope.refresh || jvDashboardFactory.isNewlyAddedWidget($scope.widgetObject) ){
                args.refresh = true;
            }
            jvDashboardAjaxService.getMyOpenJobsInfo(args, _callback);
        };

        $rootScope.$on('REFRESH_WIDGET', function(event,widgetData) {
            if(widgetData && ($scope.widgetObject.widgetId === widgetData.widgetId)){
                 //invalidate cache and fetch data from DB
                $scope.lastUpdated = '';
                $scope.refresh = true;
                userWorkflowValues = [];
                getUserWorkflows();
            }
        });

        getUserWorkflows();

        $scope.handleCreateRequisition = function () {
                $scope.showChooseReqsFormModal = true;
            };

        $scope.closeAddRequisition = function () {
                $scope.showChooseReqsFormModal = false;
            };
    }
]);